import {
  IonCard,
  IonLabel,
  IonListHeader,
  IonSlide,
  IonSlides,
  IonText,
} from "@ionic/react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAccounts } from "../../../store/account/selectors/selectAccounts";
import findPaymentNotices from "../../../store/paymentNoticesList/actions/findPaymentNotices";

export const AccountSlides: React.FC = () => {
  const dispatch = useDispatch();
  const accounts = useSelector(selectAccounts);
  const slideOpts = {
    initialSlide: 1,
    speed: 400,
  };

  const [swiper, setSwiper] = useState<any>({});

  const init = async function (this: any) {
    setSwiper(await this.getSwiper());
  };

  const onIonSlideDidChange = () => {
    if (!Number.isInteger(swiper.activeIndex)) {
      return;
    }
    dispatch({
      type: "paymentNoticesList/setAccountSelected",
      payload: accounts[swiper.activeIndex],
    });
    dispatch(findPaymentNotices());
  };
  return (
    <>
      <IonListHeader>
        <IonLabel>
          <h2>
            <strong>Cuentas</strong>
          </h2>
        </IonLabel>
      </IonListHeader>
      <IonSlides
        options={slideOpts}
        pager={true}
        onIonSlideDidChange={onIonSlideDidChange}
        onIonSlidesDidLoad={init}
      >
        {accounts &&
          accounts.map((account) => (
            <IonSlide key={account.id}>
              <IonCard
                style={{
                  height: "150px",
                  marginBottom: 0,
                  padding: "16px",
                  width: "100%",
                  textAlign: "left",
                }}
                color="primary"
              >
                <h2>
                  <strong>
                    <IonText>{account.company?.name}</IonText>
                  </strong>
                </h2>
                <h3>{account.identifier}</h3>
              </IonCard>
            </IonSlide>
          ))}
      </IonSlides>
    </>
  );
};
